"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { IconTaskTypes } from '@urbanx/agx.ui-components2'
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge'
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry'
import { useState } from 'react'
import { splitPascalCase } from 'utils/stringUtils'
import ExchangeTaskModal from './ExchangeTaskModal'

interface ExchangeTaskEntryProps {
  actionButtonId: string
  campaignId: string
  panelKey: string
  task: AutopilotTaskDto
  title: string
}

const ExchangeTaskEntry = ({
  actionButtonId,
  campaignId,
  panelKey,
  task,
  title,
}: ExchangeTaskEntryProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const displayTitle = title || splitPascalCase(task.category?.taskType ?? '')

  return (
    <>
      <ExchangeTaskModal
        campaignId={campaignId}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        task={task}
        title={displayTitle}
      />
      <TaskModalEntry
        title={displayTitle}
        tasks={[task]}
        badge={
          <TaskDueDateBadge
            dueDate={(task.dueDate ?? '') as string}
            isCompleted={task.isCompleted === true}
          />
        }
        iconType={IconTaskTypes.AwaitingExchange}
        actionText="Complete Exchange"
        actionButtonId={actionButtonId}
        panelKey={panelKey}
        onAction={() => setIsModalOpen(true)}
      />
    </>
  )
}

export default ExchangeTaskEntry
